import { render } from "./InventorySearch.vue?vue&type=template&id=44c60820&scoped=true"
import script from "./InventorySearch.vue?vue&type=script&lang=js"
export * from "./InventorySearch.vue?vue&type=script&lang=js"

import "./InventorySearch.vue?vue&type=style&index=0&id=44c60820&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c60820"]])

export default __exports__